import PageBreadcrumb from "@/components/common/PageBreadCrumb";
import { useEffect, useState } from "react";
import ResponsiveTable, { Column } from "@/components/Usados/ResponsiveTable";
import { useNavigate } from "react-router";
import { EyeIcon } from "lucide-react";
import Autocomplete from "@/components/Usados/AutoComplete";
import Select from "@/components/Usados/Select";
import Label from "@/components/Usados/Label";
import { apiFetch } from "@/service/api";

interface SesionLogin {
  id: number;
  empleado_id: {
    id: number;
    nombres: string;
    apellidos: string;
    correo_electronico: string;
  };
  fecha: string;
  tipo: string;
}

export default function ListarSesiones() {
  const [sesiones, setSesiones] = useState<SesionLogin[]>([]);
  const [filteredSesiones, setFilteredSesiones] = useState<SesionLogin[]>([]);
  const [usuariosUnicos, setUsuariosUnicos] = useState<any[]>([]);
  const [selectedUsuario, setSelectedUsuario] = useState<string>("");
  const [selectedTipo, setSelectedTipo] = useState<string>("");
  const navigate = useNavigate();

  const tiposAccion = [
    { value: "", label: "Todos" },
    { value: "Crear", label: "Crear" },
    { value: "Actualizar", label: "Actualizar" },
    { value: "Eliminar", label: "Eliminar" },
    { value: "Inicio de sesion", label: "Inicio de sesion" },
  ];

  const fetchSesiones = async () => {
    const res = await apiFetch(`acciones-historial/find-all`);
    const data = await res.json();
    setSesiones(data);
  };

  const fetchUsuariosUnicos = async () => {
    const res = await apiFetch(`acciones-historial/usuarios-unicos`);
    const data = await res.json();
    setUsuariosUnicos(data);
  };

  useEffect(() => {
    fetchSesiones();
    fetchUsuariosUnicos();
  }, []);

  useEffect(() => {
    let data = [...sesiones];
    if (selectedUsuario)
      data = data.filter((s) => String(s.empleado_id?.id) === selectedUsuario);
    if (selectedTipo) data = data.filter((s) => s.tipo === selectedTipo);
    setFilteredSesiones(data);
  }, [sesiones, selectedUsuario, selectedTipo]);

  const usuariosOptions = usuariosUnicos.map((u) => ({
    value: String(u.usuario_id),
    label: `${u.usuario_nombres} ${u.usuario_apellidos}`,
  }));

  const columns: Column<any>[] = [
    {
      label: "Usuario",
      key: "empleado_id",
      render: (val) => `${val.nombres} ${val.apellidos}`,
    },
    { label: "Tipo", key: "tipo" },
    {
      label: "Fecha",
      key: "fecha",
      render: (_, row) => row.fecha.split(" ")[0],
    },
    { label: "Hora", key: "hora", render: (_, row) => row.fecha.split(" ")[1] },
    {
      label: "Detalle",
      key: "actions",
      render: (_: any, row: any) => (
        <button
          onClick={() => navigate(`/seguridad_accesos/sesiones/ver/${row.id}`)}
          className="rounded-md p-2 hover:bg-gray-100"
        >
          <EyeIcon className="size-4" />
        </button>
      ),
    },
  ];

  return (
    <div>
      <PageBreadcrumb pageTitle="Historial de acciones" />
      <div className="rounded-2xl border bg-white p-6">
        <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
              Registro de acciones en el sistema.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
          <div>
            <Autocomplete
              label="Filtrar por usuario"
              options={usuariosOptions}
              value={selectedUsuario}
              onChange={setSelectedUsuario}
              placeholder="Seleccione un usuario"
            />
          </div>
          <div>
            <Label>Filtrar por tipo</Label>
            <Select
              options={tiposAccion}
              value={selectedTipo}
              onChange={setSelectedTipo}
              placeholder="Todos"
            />
          </div>
        </div>
        <ResponsiveTable columns={columns} data={filteredSesiones} />
      </div>
    </div>
  );
}
